import { matchRoute } from './matchRoute';

export { matchRoute };
export { matchRouteByTree } from './matchRouteByTree';
export { type Tree, Node, treeifyRoutes as treeify } from './treeifyRoutes';
export type { InvariantRoute, Match, MatchParams, Query } from './types';

export default matchRoute;
